import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  SystemUser,
  SystemUserCreate,
  SystemUserEdit,
} from '../../shared/models/system-users.models';

@Injectable({
  providedIn: 'root',
})
export class SystemUserService {
  private http = inject(HttpClient);

  createSystemUser(data: SystemUserCreate): Observable<void> {
    return this.http.post<void>('/system-user/system-users', data);
  }

  deleteSystemUser(id: number): Observable<void> {
    return this.http.delete<void>(`/system-user/system-users/${id}`);
  }

  editSystemUser(id: number, data: SystemUserEdit): Observable<void> {
    return this.http.patch<void>(`/system-user/system-users/${id}`, data);
  }

  findSystemUsers(page: number, search?: string): Observable<[SystemUser[], number]> {
    let params = new HttpParams().set('page', page);

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<[SystemUser[], number]>('/system-user/system-users', { params });
  }

  findSystemUserById(systemUserId: number): Observable<SystemUser> {
    return this.http.get<SystemUser>(`/system-user/system-users/${systemUserId}`);
  }

  findSystemUsersByIds(page: number, ids: number[]): Observable<[SystemUser[], number]> {
    if (ids.length === 0) {
      return of([[], 0]);
    }

    let params = new HttpParams().set('page', page);

    for (const id of ids) {
      params = params.append('search', id);
    }

    return this.http.get<[SystemUser[], number]>('/system-user/system-users', { params });
  }

  deleteLog(id: number): Observable<void> {
    return this.http.delete<void>(`/system-user/logs/${id}`);
  }

  changePlan(id: number, planId: number): Observable<void> {
    return this.http.patch<void>(`/system-user/system-users/${id}/plan`, { planId });
  }

  syncQuotas(serverId: string): Observable<void> {
    return this.http.patch<void>(`/system-user/system-users/servers/${serverId}/quotas`, {});
  }
}
